import React, { useState, useEffect } from 'react';
import './App.css';
import { CartProvider } from './context/CartContext';
import Header from './components/Header/Header';
import ProductGrid from './components/Products/ProductGrid';
import CartPanel from './components/Cart/CartPanel';
import BottomDock from './components/UI/BottomDock';
import ContactForm from './components/Contact/ContactForm';
import Footer from './components/Footer/Footer';
import Privacy from './components/Privacy/Privacy';
import Recipes from './components/Recipes/Recipes';
import Checkout from './components/Checkout/Checkout';
import allFlavorsImage from './assets/all_flavors.png';

function App() {
  const [route, setRoute] = useState('home');

  useEffect(() => {
    try {
      if (route === 'contact') {
        window.history.pushState({ route: 'contact' }, '', '/contact');
      } else if (route === 'products') {
        window.history.pushState({ route: 'products' }, '', '/products');
      } else if (route === 'about') {
        window.history.pushState({ route: 'about' }, '', '/about');
      } else if (route === 'privacy') {
        window.history.pushState({ route: 'privacy' }, '', '/privacy');
      } else if (route === 'recipes') {
        window.history.pushState({ route: 'recipes' }, '', '/recipes');
      } else if (route === 'checkout') {
        window.history.pushState({ route: 'checkout' }, '', '/checkout');
      } else {
        window.history.pushState({ route: 'home' }, '', '/');
      }
    } catch (e) {
      // ignore history errors in older browsers
    }
  }, [route]);

  return (
    <CartProvider>
      <div className="App">
        <Header setRoute={setRoute} />

        <main>
          {route === 'contact' ? (
            <section className="section contact-page" aria-label="Contact page">
              <div className="container">
                <div className="contact-page-card">
                  <h2 className="section-title-center">Contact Kajun Kitchen</h2>
                  <p className="section-subtitle-center">Questions about orders, wholesale, or partnerships? Send us a message and we'll reply within one business day.</p>
                  <div style={{ maxWidth: 900, margin: '0 auto' }}>
                    <ContactForm />
                  </div>
                </div>
              </div>
            </section>
          ) : route === 'privacy' ? (
            <Privacy />
          ) : route === 'recipes' ? (
            <Recipes />
          ) : route === 'checkout' ? (
            <Checkout setRoute={setRoute} />
          ) : route === 'products' ? (
            <section className="products-section">
              <div className="container">
                <h2 className="section-title-center">Our Premium Seasonings</h2>
                <p className="section-subtitle-center">Handcrafted blends that bring authentic Louisiana flavor to your kitchen</p>
              </div>
              <ProductGrid setRoute={setRoute} />
            </section>
          ) : route === 'about' ? (
            <section id="about" className="section about-section">
              <div className="container">
                <h2 className="section-title-center">The Kajun Kitchen Story</h2>
                <p className="section-subtitle-center">Where Louisiana Tradition Meets Modern Flavor Mastery</p>

                <div className="story-grid">
                  <div className="story-card heritage-card">
                    <div className="card-icon">🔥</div>
                    <h3>Rooted in Tradition</h3>
                    <p>Kajun cuisine has its roots in the French-speaking Acadian people who settled in Louisiana in the 18th century. These resilient settlers created bold, rustic dishes using local ingredients—peppers, garlic, onions—and the "holy trinity" that forms the foundation of every great Kajun meal.</p>
                  </div>

                  <div className="story-card craft-card">
                    <div className="card-icon">👨‍🍳</div>
                    <h3>Our Craft</h3>
                    <p>As a former caterer, I spent years studying the world of spices and seasonings, perfecting unique blends that tantalize the taste buds. Every bottle is packed with robust spices that add depth and complexity—just like the generations of Louisiana cooks before me.</p>
                  </div>

                  <div className="story-card quality-card">
                    <div className="card-icon">✨</div>
                    <h3>Premium Quality</h3>
                    <p>We use only the highest quality ingredients, carefully sourcing each spice and herb to ensure every bottle bursts with fresh, bold flavor. From Himalayan pink salt to hand-selected peppers, our attention to detail guarantees authentic Kajun magic in every meal.</p>
                  </div>
                </div>

                <div className="cajun-facts">
                  <div className="fact-item">
                    <i className="fas fa-pepper-hot"></i>
                    <span>Authentic Kajun spice blends trace back over 200 years of Louisiana cooking tradition</span>
                  </div>
                  <div className="fact-item">
                    <i className="fas fa-fire"></i>
                    <span>The perfect balance of heat, smoke, and savory—the hallmark of true Kajun seasoning</span>
                  </div>
                  <div className="fact-item">
                    <i className="fas fa-heart"></i>
                    <span>Handcrafted in small batches to preserve freshness and authentic flavor</span>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <>
              <section id="home" className="section hero-section">
                <div className="container">
                  <div className="hero-content-wrapper">
                    <div className="hero-brandline">
                      <span className="hero-brand">Kajun Kitchen</span>
                      <span className="hero-brand-tag">Authentic Kajun Seasonings</span>
                    </div>
                    <img src={allFlavorsImage} alt="All Kajun Kitchen Flavors" className="hero-logo" />
                    <h1>Ignite Your Taste Buds</h1>
                    <p className="hero-tagline">Authentic Kajun Seasonings That Transform Every Meal Into a Louisiana Celebration</p>
                    <p className="hero-description">Born from 200+ years of Louisiana tradition, perfected through years of culinary mastery. Our bold, handcrafted spice blends deliver the authentic heat, smoke, and soul of Kajun cooking—straight to your kitchen.</p>
                    <div className="hero-features">
                      <div className="feature-badge">
                        <i className="fas fa-check-circle"></i>
                        <span>Small Batch Crafted</span>
                      </div>
                      <div className="feature-badge">
                        <i className="fas fa-check-circle"></i>
                        <span>Premium Ingredients</span>
                      </div>
                      <div className="feature-badge">
                        <i className="fas fa-check-circle"></i>
                        <span>Authentic Kajun Flavor</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="products" className="products-section">
                <div className="container">
                  <h2 className="section-title-center">Our Premium Seasonings</h2>
                  <p className="section-subtitle-center">Handcrafted blends that bring authentic Louisiana flavor to your kitchen</p>
                </div>
                <ProductGrid setRoute={setRoute} />
              </section>

              <section id="about" className="section about-section">
                <div className="container">
                  <h2 className="section-title-center">The Kajun Kitchen Story</h2>
                  <p className="section-subtitle-center">Where Louisiana Tradition Meets Modern Flavor Mastery</p>

                  <div className="story-grid">
                    <div className="story-card heritage-card">
                      <div className="card-icon">🔥</div>
                      <h3>Rooted in Tradition</h3>
                      <p>Kajun cuisine has its roots in the French-speaking Acadian people who settled in Louisiana in the 18th century. These resilient settlers created bold, rustic dishes using local ingredients—peppers, garlic, onions—and the "holy trinity" that forms the foundation of every great Kajun meal.</p>
                    </div>

                    <div className="story-card craft-card">
                      <div className="card-icon">👨‍🍳</div>
                      <h3>Our Craft</h3>
                      <p>As a former caterer, I spent years studying the world of spices and seasonings, perfecting unique blends that tantalize the taste buds. Every bottle is packed with robust spices that add depth and complexity—just like the generations of Louisiana cooks before me.</p>
                    </div>

                    <div className="story-card quality-card">
                      <div className="card-icon">✨</div>
                      <h3>Premium Quality</h3>
                      <p>We use only the highest quality ingredients, carefully sourcing each spice and herb to ensure every bottle bursts with fresh, bold flavor. From Himalayan pink salt to hand-selected peppers, our attention to detail guarantees authentic Kajun magic in every meal.</p>
                    </div>

                    <div className="story-card tradition-card">
                      <div className="card-icon">🌶️</div>
                      <h3>200 Years of Tradition</h3>
                      <p>Authentic Kajun spice blends trace back over 200 years of Louisiana cooking tradition</p>
                    </div>

                    <div className="story-card balance-card">
                      <div className="card-icon">🔥</div>
                      <h3>Perfect Balance</h3>
                      <p>The perfect balance of heat, smoke, and savory—the hallmark of true Kajun seasoning</p>
                    </div>

                    <div className="story-card batch-card">
                      <div className="card-icon">❤️</div>
                      <h3>Small Batch Crafted</h3>
                      <p>Handcrafted in small batches to preserve freshness and authentic flavor</p>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </main>

        <CartPanel setRoute={setRoute} />
        <BottomDock setRoute={setRoute} />
        <Footer setRoute={setRoute} />
      </div>
    </CartProvider>
  );
}

export default App;
